import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderEntryService } from '../../../../services/order-entry.service';

@Component({
    selector: 'delete-dialog',
    templateUrl: 'delete-order.component.html',
    styleUrls: ['./delete-order.component.css'],
  })
  export class DeleteOrderDialog {

    order;
    orders;
    deleted = false;
    error = false;
    multiple;

    constructor(
        private orderEntryService: OrderEntryService,
        public dialogRef: MatDialogRef<DeleteOrderDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {

            if(data.length == undefined){
                this.order = data;
                this.multiple = false;
            }else{
                this.orders = data;
                this.multiple = true;
            }            
            this.error = false;
            this.deleted = false;
        }

        deleteOrder(){
            this.order.deletedTests = this.order.tests;
            this.order.addedTests = [];
            this.order.orderDate += ":00";
            this.order.ward = {
            wardId: this.order.wardId    }
            this.orderEntryService.modifyOrder(this.order).subscribe(
                data => {
                    if (data){
                        if(data.length == 0){
                            this.deleted = true;
                            this.closeDialog(true);
                        } else{
                            this.error = true;
                            this.closeDialog(false);
                        }
                        
                    }
                },
                error => {
                    this.error = true;
                    this.closeDialog(false);
                }
            );
        }

        ids = []
        deleteOrders(){
            let promises = [];
            this.ids = this.orders.map(order => ({id: order.orderId, error: undefined }));
            for(let order of this.orders){
                order.deletedTests = order.tests;
                order.addedTests = [];
                order.orderDate += ":00";
                order.ward = {
                wardId: order.wardId    }
                promises.push(this.orderEntryService.modifyOrder(order).toPromise());
            }

            for(let i = 0; i < promises.length; ++i){
                promises[i].then(
                    data => {
                        this.ids[i].error = false;
                    }
                ).catch(
                    error => {
                        this.ids[i].error = true;
                    }
                )
            }

        }

        isCancelComplete()
        {
            for(let id of this.ids)
                if (id.error == undefined){
                    return false;
                }
            if (this.ids.length == 0) return false;
            return true;
        }

        hasErrors(){
            for(let id of this.ids)
                if (id.error == true){
                    return true;
                }
            return false;
        }

        closeDialog(reload){
            setTimeout( ()=> {this.dialogRef.close(reload)}, 3000)
        }

  }